/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

export default function categorizeUserAchievements(user) {
  const categories = {};
  // hasMany returns `false`, not [], when the relation was never included — a failed
  // or partial load would otherwise throw here and abort the whole render pass.
  (user.userAchievements() || []).map(userAchievement => {
    if (!userAchievement) return null;
    const category = userAchievement.achievement().category();
    if (!categories[category.id()]) {
      categories[category.id()] = {
        name: category.name(),
        category,
        userAchievements: [userAchievement]
      };
    } else {
      categories[category.id()].userAchievements.push(userAchievement);
    }
  });
  let sortedCategories = Object.keys(categories).sort((a, b) => {
    const categoryA = categories[a].category;
    const categoryB = categories[b].category;
    if (!categoryA || !categoryB) return 0;
    if (categoryA.order() > categoryB.order()) return 1;
    if (categoryA.order() < categoryB.order()) return -1;
    return 0;
  }).map(category => categories[category]);
  sortedCategories = sortedCategories.map(category => {
    category.userAchievements = category.userAchievements.sort((a, b) => {
      if (a.achievement().order() > b.achievement().order()) return 1;
      if (a.achievement().order() < b.achievement().order()) return -1;
      return 0;
    });
    return category;
  });
  return sortedCategories;
}
flarum.reg.add('glowingblue-gamilytics', 'forum/achievements/utils/categorizeUserAchievements', categorizeUserAchievements);